<template>
  <div>
    <div class="hg-farmer" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container" v-show="!$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <GeneticSimilaritiesTopHeader />

        <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'DUAL'">
          <MixedModePeriod wayType="TWO"/>
        </template>

        <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'TRIPLE'">
          <MixedModePeriod wayType="THREE"/>
        </template>
      </div>
      <div class="result-container" v-show="$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <GeneticSimilarityProximity />
      </div>
      <div class="detail-container">
        <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'DUAL'">
          <DualOriginPopView />
        </template>
        <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'TRIPLE'">
          <TripleOriginPopView />
        </template>
      </div>
    </div>

    <template v-else>
      <GeneticSimilarityProximity v-show="$store.state.ancientProxResult.isOpenedAncientProxDetail"/>
      <div v-show="!$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <div class="genetic-similarity-mobile-other">
          <GeneticSimilaritiesTopHeader :contentPosition="contentPosition" />
          <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'DUAL'">
              <MixedModePeriod class="period-header" wayType="TWO"/>
              <DualOriginPopView />
            </template>
            
            <template v-if="$store.state.geneticSimilarities.selectedOrigin === 'TRIPLE'">
              <MixedModePeriod class="period-header" wayType="THREE"/>
              <TripleOriginPopView />
            </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import GeneticSimilaritiesTopHeader from './GeneticSimilaritiesTopHeader.vue';

import MixedModePeriod from './MixedMode/MixedModePeriod.vue';
import DualOriginPopView from './MixedMode/DualOrigin/DualOriginPopView.vue';
import TripleOriginPopView from './MixedMode/TripleOrigin/TripleOriginPopView.vue';

import GeneticSimilarityProximity from './proximity/GeneticSimilarityProximity.vue';

export default {
  components: {
    GeneticSimilaritiesTopHeader,
    MixedModePeriod,
    DualOriginPopView,
    TripleOriginPopView,
    GeneticSimilarityProximity,
  },
  data() {
    return {
      startY: 0,
      contentPosition: 250,
      minPosition: 0,
      maxPosition: 250,
    };
  },
  methods: {
    startDrag(event) {
      this.startY = event.touches[0].clientY - this.contentPosition;
    },
    onDrag(event) {
      let newY = event.touches[0].clientY - this.startY;
      if (newY < this.minPosition) newY = this.minPosition;
      if (newY > this.maxPosition) newY = this.maxPosition;
      if(newY >= 0) {
        this.contentPosition = newY;
      }
    },
    endDrag() {
      if (this.contentPosition < 245) {
        this.contentPosition = 0;
      }
    },
  },
  mounted() {
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.add('fixed-scroll-iframe');
    }
  },
  beforeDestroy() {
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.remove('fixed-scroll-iframe');
    }
  },
};
</script>

<style lang="scss" scoped>
.hg-farmer {
  width: 100%;
  display: flex;

  .result-container {
    z-index: 1;
    display: inline-block;
    position: relative;
    width: 40%;
    display: flex;
    flex-direction: column;
    height: 100vh; 
  }
  .detail-container {
    width: 60%;
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}

.genetic-similarity-mobile {
  height: 100vh;
  .mobile-map {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .mobile-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: calc(100%);
    transition: transform 0.3s ease;
    will-change: transform;
    z-index: 1001;
    
    .scrollable-wrapper {
      overflow-y: auto;
      background-color: var(--bg-body-color);
    }
  }
}

.genetic-similarity-mobile-other {
  height: 100vh;
  overflow-x: hidden;
  .period-header {
    padding-bottom: 42px;
    background-color: var(--white-100);
  }
}
</style>